import React, { useEffect, useState } from "react";
import {
  TextInput,
  Select,
  SelectItem,
  Button,
  RadioButtonGroup,
  RadioButton,
  TextArea,
  Form,
  Modal,
  InlineNotification,
} from "carbon-components-react";
import { useSelector, useDispatch } from "react-redux";
import validator from "validator";
import { Loader } from "../../components/common/loader/loader.jsx";
import { Toast } from "../../components/common/toastNofitication/toastNofitication.jsx";
import { fetchContact, contactSelector, postForm } from "./contactUs-dux";

export const ContactUs = (props) => {
  const { openContactUs, setOpenContactUs, setContactToastMessage, onHandleContactUsModal } = props;
  const dispatch = useDispatch();
  const location = window.location.pathname.split("/")[2];
  const { contactData, loading } = useSelector(contactSelector);
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [country, setCountry] = useState("");
  const [category, setCategory] = useState("");
  const [comment, setComment] = useState("");
  const [characterLimit, setCharacterLimit] = useState(0);
  const [contactUsResponse, setContactUsResponse] = useState({});
  const [showEmailError, setEmailError] = useState(false);
  const [showCategoryError, setcategoryError] = useState(false);
  const [showSubjectError, setSubjectError] = useState(false);
  const [showCommentError, setCommentError] = useState(false);

  useEffect(() => {
    dispatch(fetchContact());
  }, [dispatch]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [contactUsResponse]);

  const onChangeComment = (event, value) => {
    setComment(event.target.value);
    setCharacterLimit(event.target.value.length);
  };

  const onSubmitForm = async (event) => {
    event.preventDefault();
    if (validator.isEmail(emailId.value)) {
      setEmailError(false);
    } else {
      setEmailError(true);
    }
    if (validator.isEmpty(category)) {
      setcategoryError(true);
    } else {
      setcategoryError(false);
    }
    if (validator.isEmpty(subject)) {
      setSubjectError(true);
    } else {
      setSubjectError(false);
    }
    if (validator.isEmpty(comment)) {
      setCommentError(true);
    } else {
      setCommentError(false);
    }

    if (validator.isEmail(emailId.value) && subject !== "" && category !== "" && comment !== "") {
      let selectedCategory = contactData.data.categoryList.findIndex((obj) => obj.description == category);
      let result = await postForm(
        contactData.data.categoryList[selectedCategory].code,
        subject,
        document.getElementById("country").value,
        category,
        comment,
        emailId.value
      );

      if (result && result.data) {
        setContactUsResponse(result);
        if(result.data.status) {
          setCategory("");
          setSubject("");
          setComment("");
          setCharacterLimit(0);
          setOpenContactUs(false);
          setContactToastMessage(result.data.message)
          document.getElementById("contact-form").reset();
        }
      }
    }
  };

  const renderContactForm = () => {
    const formApiData = contactData.data.contactUsCM;
    const setDefaultCountry = contactData.data.countryList.findIndex(
      (obj) => obj.id == "1861"
    );
    return (
      <div
        className={
          location === "contactUs.do"
            ? "contact-form-wrapper"
            : "login-contact contact-form-wrapper"
        }
      >
        <Form id="contact-form" onSubmit={onSubmitForm}>
          <div className="email input-text input-wrapper">
            <label htmlFor="emailId" className="bx--label">
              {formApiData.EMAIL_LABEL}*
              <p className="ft-12 gray-60">{formApiData.EMAIL_DESC}</p>
            </label>
            <TextInput
              id="emailId"
              labelText={formApiData.EMAIL_LABEL}
              name="emailId"
              defaultValue={contactData.data.email}
              onChange={(e) => setEmail(e.target.value)}
              invalidText={formApiData.ERROR_MESSAGE_EMAIL}
              invalid={showEmailError}
              helperText={formApiData.EMAIL_LABEL}
            />
          </div>
          <div className="country input-text input-wrapper">
            <Select
              defaultValue={contactData.data.countryList[setDefaultCountry].id}
              id="country"
              labelText={formApiData.COUNTRY + "*"}
              onChange={(e) => setCountry(e.target.value)}
            >
              {contactData.data.countryList.map((cat, i) => {
                return (
                  <SelectItem key={i} text={cat.countryName} value={cat.id} />
                );
              })}
            </Select>
          </div>
          <div className="radio-group input-wrapper">
            <RadioButtonGroup
              legendText={formApiData.CATEGORY + "*"}
              name="category"
              orientation="vertical"
              id="category"
              onChange={(e) => setCategory(e)}
            >
              {contactData.data.categoryList.map((cat, key) => {
                return (
                  <RadioButton
                    key={key}
                    labelText={cat.name}
                    value={cat.description}
                    id={cat.name}
                  />
                );
              })}
            </RadioButtonGroup>
            {showCategoryError && <div role="alert" className="bx--form-requirement" id="category-error-msg">Please select category</div>}
          </div>
          <div className="subject input-text input-wrapper">
            <label htmlFor="emailId" className="bx--label">
              {formApiData.SUBJECT_LABEL + "*"}
            </label>
            <TextInput
              id="subject"
              labelText={formApiData.SUBJECT_LABEL + "*"}
              name="subject"
              onChange={(e) => setSubject(e.target.value)}
              invalidText={formApiData.ERROR_MESSAGE_SUBJECT}
              invalid={showSubjectError}
              helperText={formApiData.SUBJECT_LABEL}
            />
          </div>
          <div className="comments input-wrapper">
            <label htmlFor="comment" className="bx--label comments-label">
              {formApiData.COMMENT}*
              <p className="ft-12 gray-60"> {characterLimit}/1,000</p>
            </label>
            <TextArea
              labelText=""
              placeholder=""
              className="comment"
              onChange={onChangeComment}
              maxLength={1000}
              invalidText={formApiData.ERROR_MESSAGE_COMMENT}
              invalid={showCommentError}
            />
          </div>
          {location === "contactUs.do" && (
            <div className="button-container">
              <Button type="submit">{"Submit"}</Button>
            </div>
          )}
        </Form>
      </div>
    );
  };
  const ContactUsModule = (props) => {
    const APIData = contactData.data.contactUsCM;
    return (
      <>
        <Modal
          modalHeading={
            contactUsResponse && contactUsResponse.data ? (
              <>
                {"Contact Us"}
                {contactUsResponse && contactUsResponse.data && !contactUsResponse.data.status && (
                  <InlineNotification
                    kind={"error"}
                    title=""
                    lowContrast
                    hideCloseButton
                  >
                    <p
                      dangerouslySetInnerHTML={{
                        __html: contactUsResponse.data.message,
                      }}
                    />
                  </InlineNotification>
                )}
                {contactUsResponse && contactUsResponse.data && contactUsResponse.data.status && (
                  <Toast
                    status={"success"}
                    title=""
                    message={<p dangerouslySetInnerHTML={{ __html: contactUsResponse.data.message }} />}
                  />
                )}
              </>
            ) : (
              "Contact Us"
            )
          }
          primaryButtonText={APIData.SUBMIT_LABEL}
          secondaryButtonText={APIData.CANCEL_LABEL}
          open={openContactUs}
          onRequestClose={onHandleContactUsModal}
          onRequestSubmit={onSubmitForm}
          className="login-contact login-modal"
        >
          {renderContactForm()}
        </Modal>
      </>
    );
  };

  return (
    <div>
      {location === "contactUs.do" ? (
        loading ? (
          <Loader />
        ) : (
          <>
            <div className="main-module--padded contact-page">
              <div className="bx--grid">
                <div className="bx--row contact-bx--row">
                  <div className="bx--col-sm-12 bx--col-md-12 bx--col-lg-6">
                    {contactUsResponse && contactUsResponse.data && !contactUsResponse.data.status && (
                      <InlineNotification
                        kind={"error"}
                        title=""
                        lowContrast
                        hideCloseButton
                      >
                        <p
                          dangerouslySetInnerHTML={{
                            __html: contactUsResponse.data.message,
                          }}
                        />
                      </InlineNotification>
                    )}
                    {contactUsResponse && contactUsResponse.data && contactUsResponse.data.status && (
                      <Toast
                        status={"success"}
                        title=""
                        message={<p dangerouslySetInnerHTML={{ __html: contactUsResponse.data.message }} />}
                      />
                    )}
                    {renderContactForm()}
                  </div>
                </div>
              </div>
            </div>
          </>
        )
      ) : (
        <div>{!loading && ContactUsModule()}</div>
      )}
    </div>
  );
};
